import { AssetType } from '@/shared/api/protocol-ts/model/dto_asset_pb';

import { UploadStudyAssetType } from '../config';

export const shouldShowCreateReportToggle = (assetType: UploadStudyAssetType) =>
  assetType === AssetType.AssetType_Study_CBCT ||
  assetType === AssetType.AssetType_Study_PanoramicXRay ||
  assetType === AssetType.AssetType_Study_IntraoralXRay;
